import { Component, OnInit} from '@angular/core';
import {ActivatedRoute, Router} from '@angular/router';
import { FormGroup, FormBuilder, Validators } from '@angular/forms';
import {TranslateService} from '@ngx-translate/core';
import 'rxjs/add/operator/finally';

import { ProcessService } from 'app/core/process/process.service';
import * as Models from 'app/core/models';
import { AuthenticationService } from 'app/core/authentication/authentication.service';
import {PageTitleService} from '../shared/helpers/pageTitle.service';

@Component({
  selector: 'app-create-process',
  templateUrl: './createProcess.component.html',
  styleUrls: ['./createProcess.component.scss']
})
export class CreateProcessComponent implements OnInit {

  error: any = null;
  createProcessForm: FormGroup;
  isLoading = false;
  showForm = true;
  showSuccess = false;
  result: Models.Process = null;
  generalErrMsg: string;

  constructor(private formBuilder: FormBuilder,
              private processService: ProcessService,
              private authenticationService: AuthenticationService,
              private router: Router,
              private pageTitleService: PageTitleService,
              private actRoute: ActivatedRoute,
              private translateService: TranslateService) {
    this.createForm();
  }

  ngOnInit() {
    this.showForm = true;
    this.showSuccess = false;
    this.result = null;

    this.pageTitleService.setTitle(this.actRoute.data['value'].titleKey);

    this.translateService.get('PROCESS.CREATE.GENERAL_ERROR').subscribe((errMsg) => {
      this.generalErrMsg = errMsg;
    });
  }

  public create() {
    this.isLoading = true;
    this.processService.createProcess(this.createProcessForm.value)
      .finally(() => {
        this.createProcessForm.markAsPristine();
        this.createProcessForm.reset();
        this.isLoading = false;
        this.showForm = false;
        this.showSuccess = true;
        this.router.navigate(['/process/editing/', this.result.processId]);
      })
      .subscribe(process => {
        this.error = null;
        this.result = process;
      }, error => {
        this.error = error;
      });
  }

  get isAuthenticated(): boolean {
    return this.authenticationService.isAuthenticated();
  }

  private createForm() {
    this.createProcessForm = this.formBuilder.group({
      title: ['', Validators.required],
      description: ['', Validators.required]
    });
  }

  get errorMessage(): string {
    if (this.error) {
      const errorBody = this.error._body ? JSON.parse(this.error._body) : null;
      if (errorBody && errorBody.error) {
        return errorBody.error;
      }
    } else {
      return this.generalErrMsg;
    }
  }
}



// WEBPACK FOOTER //
// C:/ProactiView/ProactiView-Client/src/app/createProcess/createProcess.component.ts